import React from "react";
import { DualRing } from "react-spinners-css";
import Button from "../../../components/ui/Button";
import SummaryRow from "../../../components/ui/SummaryRow";
import { baseColors } from "../../../themes/tokens";
import { formatBRL } from "../../../helpers/currency.helper";
import { SummaryCard, Actions, SpinnerWrap } from "./CartSummaryActions.styles";

interface CartSummaryActionsProps {
  cartTotal: number;
  isMenuStyle: boolean;
  isSending: boolean;
  onAddMoreItems: () => void;
  onFinalizeOrder: () => void;
}

export default function CartSummaryActions({
  cartTotal,
  isMenuStyle,
  isSending,
  onAddMoreItems,
  onFinalizeOrder,
}: CartSummaryActionsProps) {
  return (
    <SummaryCard>
      <SummaryRow label="Total do pedido" value={formatBRL(cartTotal)} />
      <Actions>
        <Button variant="ghost" size="lg" full onClick={onAddMoreItems}>
          Adicionar mais itens
        </Button>
        {!isMenuStyle &&
          (isSending ? (
            <SpinnerWrap>
              <DualRing color={baseColors.teal} />
            </SpinnerWrap>
          ) : (
            <Button variant="primary" size="lg" full onClick={onFinalizeOrder}>
              Finalizar Compra
            </Button>
          ))}
      </Actions>
    </SummaryCard>
  );
}
